export var colors = {
    black: '#121212',
    white: '#fff',
    grey900: '#161616',
    grey800: '#353535',
    grey700: '#545454',
    grey600: '#676767',
    grey500: '#8f8f8f',
    grey400: '#afafaf',
    grey300: '#d3d3d3',
    grey200: '#e5e5e5',
    grey100: '#f0f0f0',
    grey50: '#f8f8f8',
    grey25: '#fbfbfb',
    nordicBlue1000: '#110c2c',
    nordicBlue900: '#0c0243',
    nordicBlue800: '#181458',
    nordicBlue700: '#201d64',
    nordicBlue600: '#27266e',
    nordicBlue400: '#494989',
    nordicBlue300: '#66679b',
    nordicBlue100: '#bbbcd4',
    nordicBlue50: '#e4e4ee',
    nordicBlue25: '#f0eff5',
    heather800: '#6f1b81',
    heather700: '#7e1f89',
    heather600: '#8f2591',
    heather200: '#cf92ca',
    heather50: '#f3e5f2',
    birch900: '#002a2d',
    birch600: '#005356',
    birch300: '#3d8083',
    birch50: '#e6f0f0',
    success900: '#1e693e',
    success800: '#2a8953',
    success500: '#41bd76',
    success200: '#a4deba',
    success50: '#e8f7ee',
    error900: '#9f0000',
    error800: '#ae120e',
    error500: '#da3119',
    error200: '#e3908b',
    error50: '#fde8ea',
    alert400: '#ffc701',
    alert200: '#ffdf7b',
    alert100: '#ffebaf',
    alert50: '#fff8df',
    economyDark: '#27266e',
    economyMedium: '#494989',
    economyLight: '#66679b',
    premiumDark: '#0c0243',
    premiumMedium: '#181458',
    premiumLight: '#201d64',
    businessDark: '#161616',
    businessMedium: '#353535',
    businessLight: '#545454',
    loyaltyBasicDark: '#f0f0f0',
    loyaltyBasicLight: '#fbfbfb',
    loyaltyBasicGradient: 'radial-gradient(125.7% 125.7% at 7.77% 7.11%, #FFF 0%, #E5E5E5 100%)',
    loyaltySilverDark: '#545454',
    loyaltySilverLight: '#767676',
    loyaltySilverGradient: 'radial-gradient(105.09% 105.09% at 13.77% 8.78%, #404040 0%, #767676 100%)',
    loyaltyGoldDark: '#68543b',
    loyaltyGoldLight: '#887159',
    loyaltyGoldGradient: 'radial-gradient(105.09% 105.09% at 7.77% 7.11%, #574630 0%, #887159 100%)',
    loyaltyPlatinumDark: '#1e1e1e',
    loyaltyPlatinumLight: '#3f3f3f',
    loyaltyPlatinumGradient: 'radial-gradient(105.09% 105.09% at 7.77% 7.11%, #000 0%, #3D3C38 100%)',
    loyaltyLumoDark: '#00231d',
    loyaltyLumoLight: '#0e3730',
    loyaltyLumoGradient: 'radial-gradient(103.66% 78.82% at 96.58% 6.11%, #2A224E 0%, #014B51 20.54%, #003D35 27.32%, #00231D 36.66%, #000 100%), radial-gradient(25.22% 25.22% at 65.91% 33.86%, #000 0%, rgba(0, 0, 0, 0.190723) 100%)',
    corporateGradient: 'radial-gradient(143.94% 137.16% at 40.47% -37.16%, #494989 0%, #0C0243 100%)',
    aurinkomatkatOrange: '#f28e00',
    aurinkomatkatOrangeLight: '#f4a433',
};
/**
 * @important Do not use these unless you are working in the new mobile app.
 *
 * These colors are temporary and will evolve over time as the new brand develops.
 */
export var atlasColors = {
    midnightBlue: '#080018',
    white: '#FFFFFF',
    white08: '#ffffff14', // 8% opacity
    white16: '#FFFFFF29', // 16% opacity
    lakeBlue: '#3772DE',
    heritageBlue: '#0C0243',
    finnairBlue: '#0A1E60',
    livingBlueGradient: 'linear-gradient(136.29deg, #0A1E60 7.24%, #3772DE 100%)',
    loyaltyBasic: '#0C0243',
    loyaltySilver: '#CED2DE',
    loyaltyGold: '#D1A068',
    loyaltyPlatinum: '#1A1D28',
    loyaltyLumo: '#002A2E',
    blueberry1000: '#4A4769',
    blueberry900: '#5F5A7D',
    blueberry800: '#6B688C',
    blueberry500: '#8F93B8',
    blueberry400: '#ACAECF',
    blueberry300: '#BBBCDA',
    blueberry200: '#C9C9E5',
    sky400: '#9EBBEF',
    sky200: '#CDDCF7',
    sky100: '#E1EAFA',
    cloud400: '#BFB7AD',
    cloud50: '#F3F3F0',
    alert500: '#CF3349',
    warning500: '#F0AA35',
    success500: '#43A663',
};
